

export const addPeople = (people) => {
    return (dispatch, getState, {getFirebase} ) => {
        // const firebase = getFirebase();
        // const firestore = firebase.firestore();
        console.log("the action is ruuning")
        const firestore = getFirebase().firestore();

        const authorId = getState().firebase.auth.uid;

        firestore
        .collection("peoples")
        .add({
            ...people,
            // authorId: authorId,
            creationDate: new Date().toString()
        })
        .then(() => {
            console.log("added successfully")

            dispatch({
                type: "ADD_PEOPLE",
                people
            });

        }).catch(err => {
            console.log("something went wrong", err)
            dispatch({
                type: "ADD_PEOPLE_ERR",
                err
            });

        });
    }
}



// remove a people 

export const removePeople = people => {
    console.log("something being triggered from People Action: ", people.id)
    return (dispatch, getState, {getFirebase}) => {
        const firestore = getFirebase().firestore();
        const authorId = getState().firebase.auth.uid;
        console.log("the action is ruuning")

        firestore
            .collection("peoples")
            .doc(people.id)
            .delete()
            .then(() => {
                console.log("deleted successfuly")
                dispatch({
                    type: "REMOVE_PEOPLE"
                });
            })
            .catch(err => {
                console.log("notdeleted successfuly")

                dispatch({
                    type: "REMOVE_PEOPLE_ERR",
                    err
                });
            });
    }
}

export const updatepeople = (people, newPeople) => {
    console.log("something updated being triggered from People Action: ", people.id)
    return (dispatch, getState, {getFirebase}) => {
        const firestore = getFirebase().firestore();
        const authorId = getState().firebase.auth.uid;
        console.log("the action is ruuning")

        firestore
            .collection("peoples")
            .doc(people.id)
            .update(newPeople)
            .then(() => {
                console.log("updated successfuly")
                dispatch({
                    type: "UPDATE_SUCCESS_PEOPLE"
                });
            })
            .catch(err => {
                console.log("updated fail")
                dispatch({
                    type: "UPDATE_PEOPLE_ERR",
                    err
                });
            });
    }
}